/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * smoothScrollToTopBtn.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * ページトップボタン
 */
 const scroll_to_top_btn = document.getElementById('totop');

 scroll_to_top_btn.addEventListener( 'click' , scroll_to_top );

 function scroll_to_top() {
	 window.scroll({ top: 0, behavior: 'smooth' });
 }

 /**
	* 表示・非表示アクション
	*/
 window.addEventListener( 'scroll' , scroll_event );

 const scroll_event = () => {

	 if(window.pageYOffset > 400){
		 scroll_to_top_btn.style.opacity = '1';
	 }else	if(window.pageYOffset < 400){
		 scroll_to_top_btn.style.opacity = '0';
	 }

 };

 export { scroll_to_top };